import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  create: {
    width: '100%',
    minHeight: '70px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
  address: {
    width: '100%',
    minHeight: '70px',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 5,
    background: '#FFF',
    color: '#999',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px',
    marginBottom: 8,
  },
  body: {
    flex: '1',
    marginLeft: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: '5px',
    color: '#000',
    fontWeight: 'bold',
    fontSize: 12,
  },
  invalid: {
    color: 'red',
  },
  buttonConfirm: {
    display: 'flex',
    width: '100%',
    height: '40px',
    borderRadius: 5,
    backgroundColor: '#FF9000',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#FF9000',
      opacity: 0.9,
    },
  },
  dialogActions: {
    padding: 20,
    marginTop: 10,
  },
}));

export default useStyles;
